<template>
  <base-panel
    :asset="asset"
    :hide-print-button="false"
    :asset-module="assetModule"
    :tabs="tabs"
    :last-update="status.lastUpdate"
    :notifications="notifications"
  />
</template>

<script>
import CoolingEfficiencyTabs from '@/domain/enums/installation/engineering/coolingEfficiency/coolingEfficiencyTabs';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import GeneralTab from '@/domain/components/installation/engineering/coolingEfficiency/general/GeneralTab';
import ChartsTab from '@/domain/components/installation/engineering/coolingEfficiency/ChartTab';
import ParametersTab from '@/domain/components/installation/engineering/coolingEfficiency/parameters/ParametersTab';
import Service from '@/domain/services/installation/engineering/coolingEfficiency/coolingEfficiencyService';
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineering';
import coolingEfficiencyEvents from '@/domain/events/coolingEfficiency';
import { CoolingEfficiencyNorms } from 'sigma-mappings';
import LoadingMixin from '@/services/loadingMixin';

export default {
  name: 'CoolingEfficiency',
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
    assetModule: {
      type: Object,
      default: () => ({}),
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [LoadingMixin],
  components: {
    BasePanel,
  },
  data: () => ({
    status: {},
    selectedNorm: CoolingEfficiencyNorms.NBR_5356_7,
  }),
  computed: {
    tabs() {
      return [
        {
          name: CoolingEfficiencyTabs.GENERAL,
          title: this.$t('general.general'),
          selectedNorm: this.selectedNorm,
          component: GeneralTab,
          status: this.status,
        },
        {
          name: CoolingEfficiencyTabs.PARAMETERS,
          title: this.$t('general.parameters'),
          component: ParametersTab,
          status: this.status,
        },
        {
          name: CoolingEfficiencyTabs.CHART,
          title: this.$t('general.chart'),
          selectedNorm: this.selectedNorm,
          component: ChartsTab,
          status: this.status,
        },
      ];
    },
  },
  created() {
    this.initListener();
    this.getStatus(true, true);
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    getStatus(showLoading, checkParam) {
      return Service.getStatus(this.assetModule.id)
        .then((response) => {
          this.status = response;
          if (checkParam) {
            this.checkInvalidParam(
              response.validMaximumExceededDifferenceTiming,
              response.algorithmExecutionCycleTime,
            );
          }
        })
        .then(() => {
          eventBus.emit(events.refreshDataTab, showLoading);
        });
    },
    checkInvalidParam(validMaximumExceededDifferenceTiming, algorithmExecutionCycleTime = 3) {
      if (validMaximumExceededDifferenceTiming) return;
      this.$pushAlert({
        code: 'MA092',
        messageParams: {
          0: this.$t('fields.engineering.cooling-efficiency.timing-diagnostic-emission-exceeded-maximum-allowable-difference'),
          1: algorithmExecutionCycleTime,
        },
      });
    },
    initListener() {
      eventBus.on(events.refreshData, this.refreshDataEvent, this);
      eventBus.on(coolingEfficiencyEvents.refreshSelectedNorm, this.selectNorm, this);
    },
    removeListener() {
      eventBus.off(events.refreshData, this.refreshDataEvent, this);
      eventBus.off(coolingEfficiencyEvents.refreshSelectedNorm, this.selectNorm, this);
    },
    selectNorm(norm) {
      this.selectedNorm = norm;
    },
    refreshDataEvent({ wait }) {
      wait(this.getStatus());
    },
  },
};
</script>

<style lang="sass" scoped>
  @media print
    ::v-deep .tabs > .tab-content > .tab-pane
      border-bottom: none
</style>
